import { isCommercialMultiAds } from './commercial/multiAds/isCommercialMultiAds';
import { IOffer } from '../../types/offer';

/**
 * Решает, должна ли карточка отображать «широкую» галерею с превью-миниатюрами.
 * Берёт серверный флаг `offer.showGalleryThumbnails` и форсит true для коммерческих
 * мультиобъявлений — у них в редизайне всегда галерея «1 большое + 3 превью».
 */
export function hasGalleryThumbnails(offer: IOffer): boolean {
  return Boolean(offer.showGalleryThumbnails) || isCommercialMultiAds(offer);
}
